<template>
  <div id="data-list-list-view" class="data-list-container">
    <div class="flex items-center justify-between mb-3"></div>
    <DriverForm
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <vx-card
      title="Drivers"
      collapse-action
      refresh-content-action
      @refresh="closeCardAnimationDemo"
    >
      <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPage"
        search
        :data="driversActive || []"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container gap-2 mb-4"
          >
            <!-- ADD NEW -->
            <div
              class="btn-add-new p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-center font-medium text-base text-primary border border-solid border-primary"
              @click="addNewData"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add Driver</span>
            </div>
            <vs-button
              :class="{ ' activeBtn': actived }"
              @click="actived = true"
              color="dark"
              type="border"
            >
              Active
            </vs-button>
            <vs-button
              :class="{ ' activeBtn': !actived }"
              @click="actived = false"
              color="dark"
              type="border"
            >
              Deactivated
            </vs-button>
          </div>
        </div>
        <template slot="thead">
          <vs-th sort-key="firstname">Full Name</vs-th>
          <!-- <vs-th sort-key="driverid">Driver ID</vs-th> -->
          <vs-th sort-key="username">Username</vs-th>
          <vs-th sort-key="codriver">Co-Driver</vs-th>
          <vs-th sort-key="vehicleid">Vehicle ID</vs-th>
          <!-- <vs-th sort-key="notes">Notes</vs-th> -->
          <vs-th sort-key="activated">Activated</vs-th>
          <vs-th sort-key="terminated">Terminated</vs-th>
          <vs-th sort-key="appversion">App Version</vs-th>
          <!-- <vs-th sort-key="deviceversion">Device Version</vs-th> -->
          <!-- <vs-th sort-key="eld">ELD</vs-th> -->
          <!-- <vs-th sort-key="status">Status</vs-th> -->
          <vs-th>Device info</vs-th>
          <vs-th class="flex justify-center"><div>Actions</div></vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody class="nmadir">
            <vs-tr  :class="[indextr % 2 === 0 ? 'bg-blue-light' : '']" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p
                  class="product-name font-medium truncate"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.name + " " + tr.last_name }}
                </p>
              </vs-td>
              <!-- <vs-td>
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.id }}
                </p>
              </vs-td> -->
              <vs-td>
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.username }}
                </p>
              </vs-td>
              <vs-td>
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.co_driver }}
                </p>
              </vs-td>
              <vs-td>
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.vehicle_id }}
                </p>
              </vs-td>
              <!-- <vs-td>
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.notes_driver || "#&" }}
                </p>
              </vs-td> -->
              <vs-td class="pr-0">
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.activated }}
                </p>
              </vs-td>
              <vs-td class="pr-2">
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.terminated || "#" }}
                </p>
              </vs-td>
              <vs-td>
                <p
                  class="product-category flex"
                  style="align-items: center"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 48 48"
                    width="28px"
                    height="28px"
                  >
                    <path
                      fill="#7cb342"
                      d="M12 29c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-1.1.9-2 2-2s2 .9 2 2V29zM40 29c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-1.1.9-2 2-2s2 .9 2 2V29zM22 40c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-1.1.9-2 2-2s2 .9 2 2V40zM30 40c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-1.1.9-2 2-2s2 .9 2 2V40z"
                    />
                    <path
                      fill="#7cb342"
                      d="M14 18v15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V18H14zM24 8c-6 0-9.7 3.6-10 8h20C33.7 11.6 30 8 24 8zM20 13.6c-.6 0-1-.4-1-1 0-.6.4-1 1-1s1 .4 1 1C21 13.1 20.6 13.6 20 13.6zM28 13.6c-.6 0-1-.4-1-1 0-.6.4-1 1-1s1 .4 1 1C29 13.1 28.6 13.6 28 13.6z"
                    />
                    <path
                      fill="#7cb342"
                      d="M28.3 10.5c-.2 0-.4-.1-.6-.2-.5-.3-.6-.9-.3-1.4l1.7-2.5c.3-.5.9-.6 1.4-.3.5.3.6.9.3 1.4l-1.7 2.5C29 10.3 28.7 10.5 28.3 10.5zM19.3 10.1c-.3 0-.7-.2-.8-.5l-1.3-2.1c-.3-.5-.2-1.1.3-1.4.5-.3 1.1-.2 1.4.3l1.3 2.1c.3.5.2 1.1-.3 1.4C19.7 10 19.5 10.1 19.3 10.1z"
                    />
                  </svg>
                  {{ tr.app_version || "2.3.3" }}
                </p>
              </vs-td>
              <!-- <vs-td>
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.device_version || "Android/2.33" }}
                </p>
              </vs-td> -->
              <!-- <vs-td>
                <vs-chip color="success" class="product-order-status">
                  ELD</vs-chip
                >
              </vs-td> -->
              <!-- <vs-td>
                <vs-chip
                  :color="getOrderStatusColor(tr.status)"
                  class="product-order-status"
                  >{{ tr.status === true ? "active" : "inactive" }}
                </vs-chip>
              </vs-td> -->
              <vs-td>
                <vs-button
                  v-if="tr.status"
                  @click="popupActivo = true"
                  size="small"
                >
                  Open
                </vs-button>
              </vs-td>
              <vs-td class="p">
                <div class="flex items-center gap-2">
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    @click.stop="editData(tr)"
                  />
                  <feather-icon
                    v-if="tr.status === true"
                    icon="XIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    @click.stop="ChangeStatus(tr, false)"
                  />
                  <feather-icon
                    v-if="tr.status === false"
                    icon="CheckIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    @click.stop="ChangeStatus(tr, true)"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
    <vs-popup
      class="holamundo"
      title="Device information"
      :active.sync="popupActivo"
    >
      <DeviceInfo />
      <div class="w-full flex justify-end items-center gap-4 mt-5">
        <vs-button type="border" @click="popupActivo = false"> Close</vs-button>
        <vs-button> Require Permissions</vs-button>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import DriverForm from "./components/DriverForm.vue";
import DeviceInfo from "./components/DeviceInfo.vue";
export default {
  components: {
    DriverForm,
    DeviceInfo,
  },
  data() {
    return {
      itemsPerPage: 6,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      actived: true,
      popupActivo: false,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    driversActive() {
      if (this.$store.state.driver.drivers.drivers) {
        return this.$store.state.driver.drivers.drivers.filter(
          (x) => x.status == this.actived
        );
      }
    },
    driversDeactive() {
      return this.$store.state.driver.drivers;
    },
  },
  methods: {
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(3000);
      setTimeout(() => {
        this.$store.dispatch("driver/fetchDataListItems");
      }, 3000);
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    ChangeStatus(tr, val) {
      this.$store
        .dispatch(`driver/updateItem`, {
          ...tr,
          status: val,
          password: null,
        })
        .then(() => {
          this.$store.dispatch("driver/fetchDataListItems");
        });
    },
    getOrderStatusColor(status) {
      if (status === true) return "success";
      if (status === false) return "danger";
      return "success";
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getOrderStatusColor(status) {
      if (status === true) return "success";
      if (status === false) return "danger";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      this.$store.dispatch("driver/fetchDataListItems");
    },
  },
  created() {
    this.$store.dispatch("driver/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<style lang="scss" scoped>
.activeBtn {
  background: #1e1e1e !important;
  color: white !important;
}
</style>
